import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'

const HAS_NEXT_AVAILABLE_LESSON = gql`
  query HasNextAvailableLesson($currentLessonId: ID!, $enrollmentId: ID!) {
    nextAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
    }
  }
`

export const useHasNextAvailableLesson = (
  currentLessonId: number,
  enrollmentId: number,
) => {
  const [hasNextAvailableLesson, { loading, error }] = useLazyQuery(
    HAS_NEXT_AVAILABLE_LESSON,
    {
      variables: { currentLessonId, enrollmentId },
    },
  )

  return { hasNextAvailableLesson, loading, error } as {
    hasNextAvailableLesson: (
      currentLessonId: number,
      enrollmentId: number,
    ) => Promise<QueryResult<{ nextAvailableLesson: { id: number } }>>
    loading: boolean
    error: ApolloError
  }
}
